import { useFormik } from "formik";
import { useSearchParams } from "react-router-dom";
import useAuth from "../../../../auth/useAuth";
import { Box, MenuItem, TextField, Button, InputLabel, FormControl, Typography, Table, TableCell, Paper, TableRow, TableBody, TableContainer, TableHead } from "@mui/material";
import { useState } from "react";
import Select from '@mui/material/Select';
import { useFetchGET } from "../../../../state/FetchHelpers";
import { usersListRoute } from "../../../../config";
import Header from "../../../../components/Header";
import useMediaQuery from "@mui/material/useMediaQuery";
import Loading from "../../../global/Loading";
import FatalError from "../../../global/FatalError";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete'
import { useExpenseManager } from "../../../hooks/expense/useExpenseManager.tsx";
import ExpenseEditDialog from "../../../dialogs/expenses/ExpenseEditDialog.jsx";
import { fee_categories, fee_payments_methods, fee_types } from "../../../../Data/dataPrueba.js";
import ConfirmDialog from "../../../dialogs/confirm/ConfirmDialog.jsx";
import { STATUSES } from "../../../../utils/Constants.js";
import { PERMISSIONS } from "../../../../utils/permissions.js";

const ExpenseManager = ({ permissionsListData }) => {
  const auth = useAuth();
  const token = auth.globals.token;
  const [searchParams] = useSearchParams();
  const prevDate = searchParams.get("date");
  const prevDriverId = searchParams.get("driver");
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [errorRequest, setErrorRequest] = useState(null);
  const [recordExpenses, setRecordExpenses] = useState([]);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [showInformation, setShowInformation] = useState(false);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const { data: usersListData, loading: usersListLoading, error: usersListError } = useFetchGET(usersListRoute(STATUSES.ACTIVE), token, []);


  const {
    getDetailExpensesByDateAndUser,
    updateExpenseByExpenseId,
    deleteExpensesFromUserById
  } = useExpenseManager();

  const getDetailExpenses = async (date, user_driver) => {
    setLoadingRequest(true)
    const data = await getDetailExpensesByDateAndUser(date, user_driver);
    setLoadingRequest(false)
    if (data === undefined) {
      setRecordExpenses([]);
      setErrorRequest(true)
    } else {
      setTotalExpenses(data.reduce((acc, item) => acc + (isNaN(parseFloat(item.amount)) ? 0 : parseFloat(item.amount)), 0));
      setRecordExpenses(Array.isArray(data) ? data : []);
    }
  }


  //update expens
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const handleEdit = (item) => {
    setSelectedExpense(item);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSaveExpense = async (updatedExpense) => {
    const payload = {
      ...updatedExpense,
      amount: String(updatedExpense.amount),
    };
    setLoadingRequest(true)
    const data = await updateExpenseByExpenseId(payload.id, payload);
    setLoadingRequest(false)
    if (data === undefined) {
      setLoadingRequest(false);
    } else {
      setLoadingRequest(false);
      getDetailExpenses(searchFormik.values.date, searchFormik.values.user_driver);
    }
  };


  //delete
  const handleDelete = async (id) => {
    setSelectedId(id);
    setConfirmOpen(true);
  };

  const handleConfirm = async (confirmed) => {
    setConfirmOpen(false);
    if (!confirmed) return;

    try {
      const response = await deleteExpensesFromUserById(selectedId);
      if (response.ok) {
        setRecordExpenses((prev) => prev.filter((e) => e.id !== selectedId));
      } else {
        console.error("Error al eliminar:", await response.json());
      }
    } catch (error) {
      console.error("Error al eliminar:", error);
    }
  };

  const performDataSearch = (values) => {
    try {
      setLoadingRequest(true);
      setShowInformation(true);
      getDetailExpenses(values.date, values.user_driver);
    } catch (error) {
      //console.log(error);
    }
  }


  const searchFormik = useFormik({
    initialValues: {
      date: prevDate || '',
      user_driver: prevDriverId || ''
    },
    onSubmit: performDataSearch
  });


  if (usersListLoading || loadingRequest)
    return (<Loading />)

  if (usersListError || errorRequest)
    return (<FatalError />)

  return (
    <Box m="20px" marginBottom="64px">
      <Header title="Control de Gastos" subtitle="Control de gastos" />

      <form onSubmit={searchFormik.handleSubmit}>
        <Box display="grid"
          gap="15px"
          marginBottom="15px"
          gridTemplateColumns="repeat(12, minmax(0, 1fr))"
          sx={{
            "& > div": { gridColumn: isNonMobile ? undefined : "span 12" }
          }} >

          <TextField
            disabled={false}
            fullWidth={!isNonMobile}
            variant="filled"
            type="date"
            label="Fecha"
            asp-format="{0:yyyy-MM-dd}"
            name="date"
            value={searchFormik.values.date}
            onChange={searchFormik.handleChange}
            size="small"
            sx={{ gridColumn: "span 3" }}
            required
          />

          <FormControl variant="filled"
            disabled={false}
            sx={{ gridColumn: "span 5" }}
            required>
            <InputLabel id="select-driver-label" name="select-driver-label">Usuario</InputLabel>
            <Select
              labelId="select-driver-label"
              id="select-driver"
              fullWidth={!isNonMobile}
              name="user_driver"
              size="small"
              value={searchFormik.values.user_driver}
              onChange={searchFormik.handleChange}
            >

              {usersListData.map((user) => (
                (permissionsListData.includes(PERMISSIONS.VIEW_EXPENSES_OF_OTHER_USERS) ?
                  <MenuItem key={user.id} value={user.id.toString()}>
                    {user.name + ' ' + user.lastname}
                  </MenuItem>
                  : user.id === auth.globals.id ?
                    <MenuItem key={user.id} value={user.id.toString()}>
                      {user.name + ' ' + user.lastname}
                    </MenuItem>
                    : undefined)
              ))}
            </Select>
          </FormControl>

          <Button type="submit" variant="contained" color="secondary">
            Buscar
          </Button>
        </Box>
      </form>

      {showInformation && (
        <Box sx={{ marginTop: 2 }}>
          <Typography variant="h5" sx={{ marginBottom: 2, fontWeight: 'bold' }}> Gastos </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell component="th" style={{ fontWeight: 'bold' }}>Categoría de gasto </TableCell>
                  <TableCell component="th" style={{ fontWeight: 'bold' }}> Tipo de gasto &nbsp; </TableCell>
                  <TableCell component="th" style={{ fontWeight: 'bold' }}>Tipo de Pago&nbsp; </TableCell>
                  <TableCell component="th" style={{ fontWeight: 'bold' }}> Monto &nbsp; </TableCell>
                  <TableCell component="th" style={{ fontWeight: 'bold' }}> Descripción &nbsp; </TableCell>
                  <TableCell component="th" style={{ fontWeight: 'bold' }}> Opciones &nbsp; </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {recordExpenses && recordExpenses.map((item) =>
                  <TableRow key={item.id}>
                    <TableCell >{item.category}</TableCell>
                    <TableCell >{item.fee_type}</TableCell>
                    <TableCell >{item.payment_type}</TableCell>
                    <TableCell >{item.amount}</TableCell>
                    <TableCell >{item.fee_description}</TableCell>
                    <TableCell >
                      <Box sx={{ display: "flex", gap: 1 }}>
                        {(permissionsListData.includes(PERMISSIONS.EDIT_EXPENSE) &&
                          <Button
                            color="secondary"
                            size="small"
                            variant="contained"
                            startIcon={<EditIcon />}
                            onClick={() => handleEdit(item)}
                          >
                            Editar
                          </Button>)}
                        {(permissionsListData.includes(PERMISSIONS.DELETE_EXPENSE) && <Button
                          color="error"
                          size="small"
                          variant="contained"
                          startIcon={<DeleteIcon />}
                          onClick={() => handleDelete(item.id)}
                        >
                          Eliminar
                        </Button>)}
                      </Box>
                    </TableCell>
                  </TableRow>)}
                {recordExpenses.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No hay gastos para mostrar.
                    </TableCell>
                  </TableRow>
                )}

                <TableRow>
                  <TableCell />
                  <TableCell />
                  <TableCell style={{ fontWeight: 'bold' }}> Total </TableCell>
                  <TableCell style={{ fontWeight: 'bold' }}> {totalExpenses} </TableCell>
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>)}
      {/* Diálogo para editar gasto */}
      <ExpenseEditDialog
        open={openDialog}
        onClose={handleCloseDialog}
        item={selectedExpense}
        onSave={handleSaveExpense}
        categories={fee_categories}
        feeTypes={fee_types}
        paymentTypes={fee_payments_methods}
        date={searchFormik.values.date}
      />
      {/* Diálogo de confirmación */}
      <ConfirmDialog
        open={confirmOpen}
        title="Eliminar gasto"
        message="¿Estás seguro de que deseas eliminar este gasto? Esta acción no se puede deshacer."
        onClose={handleConfirm}
      />
    </Box>

  );
}

export default ExpenseManager;